import { Updatable } from '../../..';

export default class CashfreeSettings extends Updatable {
    public clientKey: string;
    public secretKey: string;
    public testMode: boolean;
    public widgetMode: boolean;

    constructor(settings?: Partial<CashfreeSettings>) {
        super();
        if (settings) this.update(settings);
    }

    update(entity: Partial<CashfreeSettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }

    toJson() {
        return {
            ...this
        }
    }
}